import { useState, useEffect } from 'react';

const isSSR = typeof window === 'undefined';

export default function useImageLoader(src?: string) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // nothing to do if there is no image or we are in ssr
    if (isSSR || !src) {
      return;
    }

    // If no loader was setup yet, or if we want to load a new image, configure
    // `src` and `onload` so that we trigger a state change when the image loads
    setLoaded(false);
    const imageLoaderElement = new Image();
    imageLoaderElement.onload = () => setLoaded(true);
    imageLoaderElement.src = src;

    return () => {
      imageLoaderElement.onload = null;
    };
  }, [src]);

  // Bypass the loader if no image was provided
  if (!src) {
    return true;
  }

  return loaded;
}
